import { render, staticRenderFns } from "./BatchShareView.vue?vue&type=template&id=35696542&scoped=true"
import script from "./BatchShareView.vue?vue&type=script&lang=js"
export * from "./BatchShareView.vue?vue&type=script&lang=js"
import style0 from "./BatchShareView.vue?vue&type=style&index=0&id=35696542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35696542",
  null
  
)

export default component.exports